import React, { useState } from "react";
import colors from "../constants/colors";

const QuantitySelector = ({ quantity, onChangeQuantity, isFromModal, mainContainerStyle = {}, }) => {
  const handleIncrease = () => {
    onChangeQuantity(quantity + 1);
  };

  const handleDecrease = () => {
    if (isFromModal && quantity === 1) {
      onChangeQuantity(0);
    } else if (quantity > 1) {
      onChangeQuantity(quantity - 1);
    }
  };

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "row", 
      alignItems: "center", 
      justifyContent: "center", 
      paddingLeft: 15,
      ...mainContainerStyle, 
      }}>
      <button
        onClick={handleDecrease}
        style={{
          backgroundColor: (quantity === 1 || (isFromModal && quantity === 0)) ? "gray" : colors.primary,
          width: 40,
          height: 40,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 20,
          border: "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        disabled={
          (!isFromModal && quantity === 1) || (isFromModal && quantity === 0)
        }
      >
        <span style={{ color: "white", fontSize: 20 }}>-</span>
      </button>
      <span style={{ margin: '0px 14px', fontSize: 18 }}>{quantity}</span>
      <button
        onClick={handleIncrease}
        style={{
          backgroundColor: colors.primary,
          width: 40,
          height: 40,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 20,
          border: "none",
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ color: "white", fontSize: 20 }}>+</span>
      </button>
    </div>
  );
};

export default QuantitySelector;